import React from 'react';

import theme from '@/styles/theme';

interface Props {
  size?: number;
  fill?: string;
}
const Symbol = ({ size = 14, fill = theme.color.primary600 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id=" image_booking_symbol">
        <g id="Group">
          <path
            id="Subtract"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.33333 0C1.04467 0 0 1.04467 0 2.33333V11.6667C0 12.9553 1.04467 14 2.33333 14H7C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0H2.33333ZM5.25 4.75C5.25 4.05964 5.80964 3.5 6.5 3.5C7.19036 3.5 7.75 4.05964 7.75 4.75V5.75H8.75C9.44036 5.75 10 6.30964 10 7C10 7.69036 9.44036 8.25 8.75 8.25H7.75V9.25C7.75 9.94036 7.19036 10.5 6.5 10.5C5.80964 10.5 5.25 9.94036 5.25 9.25V8.25H4.25C3.55964 8.25 3 7.69036 3 7C3 6.30964 3.55964 5.75 4.25 5.75H5.25V4.75Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export default Symbol;
